const supported = value => value === 'es' ? 'es' : 'en';
let current = 'en';
export const syncLanguageStorage = () => { try { current = supported(localStorage.getItem('selectedLanguage')); } catch { /* Keep the in-memory choice. */ } return current; };
syncLanguageStorage();
export const getLanguage = () => current;
export const observeLanguage = value => { current = supported(value); return current; };
export const getLocale = () => getLanguage() === 'es' ? 'es-ES' : 'en-US';
export const saveLanguage = value => {
  const language = supported(value);
  current = language;
  try { localStorage.setItem('selectedLanguage', language); } catch { /* In-memory selection still works. */ }
  window.dispatchEvent(new CustomEvent('stg-language', { detail: language }));
};